import React from "react";
import MainWrapper from "../components/MainWrapper";
import GuestbookPage from "../components/GuestbookPage";
import { GuestbookProvider, useGuestbook } from "../context/guestbook";

export default function GuestBookScreen() {
  return (
    <MainWrapper>
      <GuestbookProvider>
        <GuestbookPage />
      </GuestbookProvider>
    </MainWrapper>
  );
}
